import React from 'react'
import ReactStars from 'react-stars'
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions } from '../../../store';
import { toast } from "react-toastify";
import axios from 'axios' 

const QuestionBody = ({ index, setIndex, Question, QuestionType, Required, Option, length }) => {
    const dispatch = useDispatch();
    const reviewDetails = useSelector((state) => state.EMenu.questionDetails);
    const auth_token = useSelector((state) => state.Company.auth_token);
    const C_URL = useSelector((state) => state.Company.c_url);
    const userEmail = useSelector((state) => state.User.userEmail);
	const userName = useSelector((state) => state.User.userName);
	const userPhone = useSelector((state) => state.User.userPhone);
    // console.log(reviewDetails);
    const [radioValue, setRadioValue] = React.useState([]);
    const [message, setMessage] = React.useState([]);
    const [warning, setWarning] = React.useState(true);
    const [rating, setRating] = React.useState([]);

    // event handler for rating questions
    const ratingChanged = (newRating) => {
        const ratings = [...rating];
        ratings[index] = newRating;
        // console.log("*",newRating)
        setRating(ratings);
        if(newRating > 0){
            console.log(rating);
        }
    }
    // event handler for text questions
    const chHandleMessage = (e) => {
        const newMessage = [...message];
        const value  = e.target.value;
        newMessage[index] = value;
        if(value.trim !== ''){
            setWarning(false);
        }
        setMessage(newMessage);
        // console.log(message);
    }
    //event handler for radio questions
    const chHandleRadio = (e) => {
        const newRadioValues = [...radioValue];
        const value = e.target.value;
        newRadioValues[index] = value;
        setRadioValue(newRadioValues);
        // console.log(radioValue);
    };

    // event handler for NEXT button
    const handleNext = (e) => {
        e.preventDefault();
        if (Required === "1" && QuestionType === 'text' && !message[index]){
            // console.log("it is required");
            setWarning(true);
        }else{
            setWarning(false);
            if (index < length - 1) {
                setIndex(index + 1);
            }
            saveTheAnswer();
        }
    };

        // event handler for BACK button
    const handlePrevious = (e) => {
        e.preventDefault();
        if (index > -1) {
            setIndex(index - 1);
        // console.log(index);
        }
    };

    // event handler for to submit the review questions
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        await saveTheAnswer();
        // review infromation
        await continueSubmit();
    }

    const saveTheAnswer = async() => {
        let reviewAnswers = '';
    switch (QuestionType){
        case 'text':
            reviewAnswers = message[index];
            break;
        case 'radio':
            reviewAnswers = radioValue[index];
            break;
        case 'rating':
            reviewAnswers = rating[index];
            break;
            default:
                reviewAnswers = '';
                break;
            }
            // console.log("message", message);
            const existingDetails = reviewDetails.filter(detail => detail.answers[0].id === index);
            if(existingDetails.length === 0){
                dispatch(EMenuActions.setQuestionDetails([
                    ...reviewDetails,
                    {
                        answers: [{
                            id: index,
                        answer: reviewAnswers,
                        }]
                    },
                ]));
                }else{
                    const changeAnswer = reviewDetails.map(detail => 
                        detail.answers[0].id === index ? { answers: [{...detail.answers, answer: reviewAnswers}] } : detail
                    );
                    dispatch(EMenuActions.setQuestionDetails(changeAnswer));
                }
                console.log(reviewDetails)
}

    const continueSubmit = async() => {
        const customerInfo = [{
            id: "",
            name: userName,
            email: userEmail,
            phone: userPhone,
        }];
        //review questions information
        const reviewQuestionInfo = [
            {
                ip_address: "",
                BranchId: "1"
            }
        ];
        //review
        const data = {
            customerInfo: customerInfo,
            reviewQuestionInfo: reviewQuestionInfo,
            reviewQuestionDetail: reviewDetails,
        }
        const stringify = JSON.stringify(data);

        // console.log("to submit:", stringify);

        // submit the reivew
            await axios.post(`https://${C_URL}/api/v1/CustomerReview`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${auth_token}`,
                        ContentType: 'application/json'
                    },
                }
            ).then((res) => {
                //submit success
                // console.log(res.status);
                toast.success("Thanks for your feedback! ", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setMessage([]);
                setRadioValue([]);
                setRating([]);
                dispatch(EMenuActions.setReview(false));
            }).catch((e) =>{
            console.error("Error submitting review:", e);
        });
    } 


    const showQuestionType = (QuestionType) => {
        switch (QuestionType) {
            case 'text':
                return <textarea id="message" rows="4" className=" p-2.5 w-[85%] text-sm text-gray-900 bg-dark/10 rounded-lg border-none mt-0.5" placeholder="Your message..."
                onChange={chHandleMessage}
                value={message[index]}
                ></textarea>;
            case 'radio':
                return <div className="flex justify-center items-center">
                    <div className='px-3 flex items-center'>
                        <label className='font-bold px-2'>{Option}</label>
                        <input 
                        className="w-5 h-5" 
                        type="radio" 
                        name="radio"
                        checked={radioValue[index] === Option}
                        value={Option} 
                        onChange={chHandleRadio}
                        />
                    </div>
                    <div className='px-3 flex items-center'>
                        <label className='font-bold px-2' >No</label>
                        <input 
                        type="radio" 
                        className="w-5 h-5" 
                        name="radio" 
                        checked={radioValue[index] === 'No'}
                        value="No"
                        onChange={chHandleRadio}
                        />
                    </div>
                </div>;
            case 'rating':
                return <div className="flex justify-center">
                <ReactStars
                count={5}
                onChange={(newRating) => ratingChanged(newRating)}
                value={rating[index] || 0}
                size={65}
                color2={'#ffd700'} />
            </div>;
            default:
                return null;
        }
    }

    return (
        <div className='flex h-full md:h-[90%] justify-center items-center flex-col align-center mt-8'>
            <label className="text-sm text-center font-bold my-5">{Question}</label>
            {showQuestionType(QuestionType)}
        <div>{warning ? <span className='text-danger font-bold'> * please share your experience with us</span> : <></>}</div>
                <div className='absolute flex items-end bottom-10 mt-12 h-[30%] w-[85%]'>
                <div className='flex w-full justify-between'>
                    <button className={`${index === -1 ? 'bg-white': 'bg-dark/30 hover:bg-dark/70'} py-3 w-[20%] text-center rounded-sm bg-dark/ text-white`}
                    onClick={handlePrevious}
                    disabled={index=== -1 ? true: false}
                    >
                        {' '}
                        <span>BACK</span>
                    </button>
                    <button 
                    className={`${length -1 > index ? "" : "hidden"} py-3 text-center rounded-sm w-[20%] hover:bg-secondary bg-secondary/70 text-white`}
                    onClick={(e) => handleNext(e)}
                    >
                        {' '}
                        <span>NEXT</span>
                    </button>
                    <button 
                    className={`${length -1 !== index ? "hidden" : ""} py-3 text-center rounded-sm w-[20%] hover:bg-secondary bg-secondary/70 text-white`}
                    onClick={(e) => handleSubmit(e)}
                    >
                        {' '}
                        <span>SUBMIT</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default QuestionBody
